export default __webpack_public_path__ + "img/ZXMLcXLt.8050dab5.svg";